import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = {
  key: 0,
  class: "absolute-top-left header__fix"
}
const _hoisted_3 = { class: "column q-gutter-y-md absolute-center text-center full-width" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "header__fix" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "container text-h4 text-center" }
const _hoisted_8 = {
  key: 0,
  class: "header__fix absolute-top-left container q-py-md",
  style: {"z-index":"10"}
}
const _hoisted_9 = { class: "flex justify-between items-center" }
const _hoisted_10 = { class: "q-pt-md" }
const _hoisted_11 = { class: "container q-py-lg" }
const _hoisted_12 = { class: "row q-col-gutter-lg" }
const _hoisted_13 = { class: "col-12 col-sm-7" }
const _hoisted_14 = { class: "row q-col-gutter-y-lg" }
const _hoisted_15 = { class: "row q-gutter-y-lg full-width" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  key: 0,
  class: "text-caption text-grey-6"
}
const _hoisted_18 = { class: "text-h3 q-mt-none q-mb-sm" }
const _hoisted_19 = { class: "flex c-dot-list" }
const _hoisted_20 = {
  key: 0,
  class: "text-bold"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = {
  key: 0,
  class: "col-12"
}
const _hoisted_26 = {
  class: "flex font-inter-bold",
  style: {"column-gap":"8px"}
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "flex no-wrap items-center q-gutter-md" }
const _hoisted_30 = { class: "text-muted text-xsmall" }
const _hoisted_31 = { class: "col-12 q-mb-md" }
const _hoisted_32 = {
  key: 0,
  class: "col-12"
}
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = {
  key: 1,
  class: "col-12"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "text-h3 q-mb-sm" }
const _hoisted_41 = { class: "text-right" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = {
  key: 2,
  class: "col-12"
}
const _hoisted_45 = { class: "q-mt-md text-small text-grey-7" }
const _hoisted_46 = { class: "text-small" }
const _hoisted_47 = ["href"]
const _hoisted_48 = {
  key: 3,
  class: "col-12"
}
const _hoisted_49 = { class: "col-12 col-sm-5" }
const _hoisted_50 = { class: "flex column no-wrap q-gutter-y-md full-height" }
const _hoisted_51 = { class: "price-box--wrapper sticky-price" }
const _hoisted_52 = { class: "flex column full-width no-wrap q-gutter-y-sm" }
const _hoisted_53 = {
  key: 0,
  class: "font-inter-bold q-mt-md",
  style: {"font-size":"2rem","line-height":"2rem"}
}
const _hoisted_54 = {
  key: 1,
  class: "text-grey-8 text-h4"
}
const _hoisted_55 = {
  key: 0,
  class: "q-mb-md"
}
const _hoisted_56 = {
  key: 1,
  class: "q-pt-md"
}
const _hoisted_57 = ["href"]
const _hoisted_58 = { class: "flex q-gutter-md" }
const _hoisted_59 = { class: "col-grow" }
const _hoisted_60 = { class: "col-grow" }
const _hoisted_61 = ["data-amount"]

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { Advert } from 'src/models/advert'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { date, useMeta, useQuasar } from 'quasar'
import DetailEditBar from 'src/components/adverts/DetailEditBar.vue'
import MessageUserButton, { createMessage } from 'src/components/adverts/MessageUserButton.vue'
import AdvertEquipmentCard from 'src/components/adverts/detail/AdvertEquipmentCard.vue'
import AdvertDetailExtras from 'src/components/adverts/detail/AdvertDetailExtras.vue'
import { getCityFromNominatim, truncate } from 'src/etc/utils'
import AdvertRecommendation from 'src/apps/adverts/components/AdvertRecommendation.vue'
import GalleryModal from 'components/qutils/GalleryModal.vue'
import FadeOutText from 'components/qutils/FadeOutText.vue'
import AdvertLocationMap from 'src/apps/adverts/components/AdvertLocationMap.vue'
import { useTracking } from 'src/etc/tracking'
import BookmarkBtn from 'src/apps/core/components/BookmarkBtn.vue'
import Filter from '../etc/qutils/filter'
import FlagIcon from 'src/apps/core/components/FlagIcon.vue'
import { shareAdvert } from 'src/apps/adverts/helper'
import DetailHeaderGallery from 'src/apps/adverts/components/DetailHeaderGallery.vue'
import FixedAdvertDetailFooterBar from 'src/apps/adverts/components/FixedAdvertDetailFooterBar.vue'
import { showLoginDialog } from 'src/etc/helper'
import AdvertDetailCrossSellingProducts from 'components/adverts/detail/AdvertDetailCrossSellingProducts.vue'
import AdvertDetailAd from 'src/apps/ads/components/AdvertDetailAd.vue'
import { askUserForRating } from 'src/apps/core/utils'
import vOnEleLoad from 'src/directive/onEleLoad'



import { useMainStore } from 'stores/main'

const __default__ = {
  preFetch({
             store,
             currentRoute,
             // previousRoute,
             // ssrContext,
             redirect,
             urlPath
             // publicPath,
           }) {
    const mainStore = useMainStore(store)
    const uuid = currentRoute.params.uuid
    return mainStore.fetchAdvert(uuid).catch((err) => {
      const { response } = err
      if (response?.data?.detail == 'not active') {
        mainStore.adverts[currentRoute.params.uuid as string] = {
          inactive: true
        }
        return err
      }
      if ([404, 400].includes(response?.status)) {
        redirect({ name: '404', query: { url: urlPath } })
      }
      return err
    })
  }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AdvertDetailPage',
  setup(__props) {

const mainStore = useMainStore()
const $route = useRoute()
const advert = ref<Advert | undefined>(undefined)
const message = ref()
const loading = ref(false)
const $q = useQuasar()
const isMessageSend = ref(false)
const router = useRouter()
const uuid = Array.isArray($route.params.uuid)
  ? $route.params.uuid[0]
  : $route.params.uuid
const clickedShowPhone = ref(false)
const loadingShare = ref(false)

const showFixedBar = ref(true)
const priceBox = ref<HTMLElement | null>(null)

const parsedImages = computed(() => {
  if (!advert.value?.images) {
    return []
  }
  return advert.value.images.flatMap((obj) => {
    return {
      file: obj.image?.path,
      thumb: obj.image_thumbnail_gallery?.path ?? obj.image?.path
    }
  })
})

const advertImages = computed(() => {
  if (!advert.value?.images?.length) return []
  return advert.value?.images?.flatMap(
    (obj) => obj.image_thumbnail_detail
  )
})

const isOwner = computed(() => {
  return advert.value?.is_owner
})

const checkVisibilityFixedFooter = (entries) => {
  entries.forEach(entry => {
    if (!priceBox.value) {
      console.warn('priceBox value not defined')
      return
    }
    const priceBoxBottomDistanceToTop = priceBox.value?.getBoundingClientRect().top

    showFixedBar.value = !entry.isIntersecting && (priceBoxBottomDistanceToTop > 0 || window.scrollY === 0)
  })
}

// Refresh advert if user is logged in to get the correct phone number
watch(
  () => mainStore.loggedInState,
  (value) => {
    if (value) {
      mainStore.fetchAdvert(uuid).then(() => {
        advert.value = mainStore.adverts[uuid]
      })
    }
  },
  { once: true, immediate: false }
)


let observer, observerFixedFooter

onMounted(() => {
  if (mainStore.adverts.hasOwnProperty(uuid)) {
    advert.value = mainStore.adverts[uuid]
  }
  observerFixedFooter = new IntersectionObserver(checkVisibilityFixedFooter, {
    root: null,
    threshold: [0.7, 1]
  })

  initTarifCheck()

  // check for rating
  askUserForRating($q, mainStore)
})

watch(
  () => priceBox.value,
  () => {
    if (priceBox.value && observerFixedFooter) {
      observerFixedFooter.observe(priceBox.value)
    }
  }
)

function initTarifCheck() {
  let versicherungScript = document.createElement('script')
  versicherungScript.setAttribute('src', 'https://form.partner-versicherung.de/widgets/181074/tcpp-widget-kredit/kredit-widget.js')
  document.head.appendChild(versicherungScript)
}

// reload traif check widget on route change
watch(
  () => $route.params.uuid,
  (newUuid, oldUuid) => {
    if (newUuid !== oldUuid) {
      initTarifCheck()
    }
  },
  {}
)

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }

  if (observerFixedFooter) {
    observerFixedFooter.disconnect()
  }
})

const hasHistory = computed(() => {
  return window && window.history?.length > 0 && window.history.state?.back !== null
})

const priceBoxOnLoad = (ele: HTMLElement) => {
  if (observer) {
    observer.observe(ele)
  }
}

const dateJoined = computed(() => {
  let d = advert.value?.by_user?.date_joined || advert.value?.by_user?.created_at
  if (!d) return
  return new Date(d).toLocaleDateString('de', {
    month: 'short',
    year: 'numeric'
  })
})


const sendMessage = function() {
  if (advert.value?.by_user?.uuid && advert.value?.uuid) {
    createMessage(message.value, { advertUuid: advert.value?.uuid })
      .then(() => {
        isMessageSend.value = true
      })
      .catch((err) => {
        console.error(err)
      })
  }
}

const showPhone = function() {
  if (!mainStore.isLoggedIn && !advert.value?.by_business) {
    showLoginDialog()
    return
  }
  const tracker = useTracking()
  tracker.trackInteractionPhone('advert')
  clickedShowPhone.value = true
}

const formattedMileage = computed(() => {
  if (!advert.value?.vehicle?.mileage) return
  const number = advert.value?.vehicle.mileage
  return new Intl.NumberFormat('de-DE', { maximumSignificantDigits: 3 }).format(number)
})

const formattedPrice = computed(() => {
  if (!advert.value?.price) return
  return Filter.currency({
    value: advert.value.price,
    maximumFractionDigits: 0
  })
})

async function share() {
  if (!advert.value) {
    console.warn('advert is undefined')
    return
  }
  loadingShare.value = true

  await shareAdvert($q, advert.value)

  loadingShare.value = false
}

onBeforeRouteUpdate((to, from, next) => {
  if (to.params.uuid !== from.params.uuid) {
    loading.value = true
    advert.value = undefined
    const _uuid = Array.isArray(to.params.uuid) ? to.params.uuid[0] : to.params.uuid
    if (mainStore.adverts.hasOwnProperty(_uuid)) {
      advert.value = mainStore.adverts[_uuid]
      loading.value = false

    } else {
      mainStore.fetchAdvert(_uuid).then(() => {
        advert.value = mainStore.adverts[_uuid]
      }).finally(() => {
        loading.value = false
      })
    }
  }
  next()
})

function openGallery(position) {
  $q.dialog({
    component: GalleryModal,
    componentProps: {
      images: parsedImages.value,
      position: position
    }
  })
}

const toProfile = computed(() => {
  if (advert.value?.by_business && advert.value?.by_user?.slug) {
    return { name: 'business-profile', params: { slug: advert.value?.by_user?.slug } }
  }
  return { name: 'profile', params: { uuid: advert.value?.by_user?.uuid } }
})

const getJsonLd = function(item: Advert) {
  if (!item) return {}

  let registrationDate
  try {
    registrationDate = new Date(
      item.vehicle.registration_iso
    ).toISOString()
  } catch (err) {
    console.error(err)
  }
  const validUntil = date.addToDate(new Date(), { days: 90 })
  const images = item.images?.flatMap((obj) => obj.image.path)
  let offeredBy: undefined | object = undefined
  if (item.by_business && item.by_business?.slug) {
    offeredBy = {
      '@type': 'AutoDealer',
      '@id': router.resolve({
        name: 'business-profile',
        params: { slug: item.by_business.slug }
      }).fullPath,
      telephone: item.by_business.phone,
      name: item.by_business.public_name,
      image: item.by_business.avatar?.path,
      address: {
        '@type': 'PostalAddress',
        streetAddress: item.by_business.address?.street_and_number,
        addressLocality: item.by_business.address?.city,
        postalCode: item.by_business.address?.zip_code,
        addressCountry: item.by_business.address?.country
      }
    }
  } else {
    offeredBy = {
      '@type': 'Person',
      name: item.by_user?.name,
      address: {
        '@type': 'PostalAddress',
        addressLocality: item.address.city,
        postalCode: item.address.zip_code
      },
      image: item.by_user?.avatar ? item.by_user?.avatar['path'] : ''
    }
  }

  return {
    person: {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org/',
        '@type': 'ProfilePage',
        mainEntity: offeredBy
      })
    },

    car: {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org/',
        '@type': ['Product', 'Car'],
        name: `${item.vehicle.car_type_display} ${item.vehicle.brand_display} ${item.vehicle.model}`.trim(),
        image: images?.length ? images[0] : undefined,
        sku: `${item.uuid}`,
        vehicleIdentificationNumber: item.vehicle.vin ?? '',
        color: item.vehicle.equipment?.color_display || '',
        description: `Finde jetzt deinen ${item.vehicle.brand_display} ${item.price}€ Camper auf Camper Trader, dein Marktplatz für Camper.`,
        brand: {
          '@type': 'Brand',
          name: item.vehicle.brand_display
        },
        model: item.vehicle.model ?? '',
        itemCondition: 'https://schema.org/UsedCondition',
        vehicleModelDate: item.vehicle.year ?? '',
        mileageFromOdometer: {
          '@type': 'QuantitativeValue',
          value: item.vehicle.mileage ?? '',
          unitText: 'KM',
          unitCode: 'KMT'
        },
        driveWheelConfiguration: item.vehicle.all_wheel_drive ? 'https://schema.org/AllWheelDriveConfiguration' : '',
        vehicleEngine: [
          {
            '@type': 'EngineSpecification',
            enginePower: [
              {
                '@type': 'QuantitativeValue',
                value: item.vehicle.engine_power_ps,
                unitCode: 'BHP'
              },
              {
                '@type': 'QuantitativeValue',
                value: item.vehicle.engine_power_kw,
                unitCode: 'KWT'
              }
            ]
          }
        ],
        vehicleTransmission: item.vehicle.transmission_display,
        vehicleSeatingCapacity: item.vehicle.seats ?? '',
        numberOfPreviousOwners: item.vehicle.number_of_owners,

        hasEnergyConsumptionDetails: {
          '@type': 'EnergyConsumptionDetails',
          energyEfficiencyScaleMax: 'Euro 6d',
          energyEfficiencyScaleMin: 'Euro 1',
          hasEnergyEfficiencyCategory: item.vehicle.environmental_badge_display
        },

        offers: {
          '@type': 'Offer',
          price: item.price,
          priceCurrency: 'EUR',
          priceValidUntil: date.formatDate(validUntil, 'YYYY-MM-DD'),
          availability: 'InStock',
          url: router.resolve({
            name: 'listingDetail',
            params: { slug: item.seo_slug, uuid: item.uuid }
          }).fullPath,
          offeredBy: offeredBy
        }
      })
    }
  }
}

const setMeta = function() {
  const item: Advert = mainStore.adverts[uuid]

  if (!item || item?.inactive) return

  useMeta(() => {
    return {
      titleTemplate(title) {
        return `${item.seo_title} | ${title}`
      },

      // link: [{rel: 'canonical', href: canonical}],
      script: getJsonLd(item),

      link: {
        canonical: {
          rel: 'canonical',
          href: router.resolve({
            name: 'listingDetail',
            params: { slug: item.seo_slug, uuid: item.uuid }
          }).fullPath
        }
      },

      meta: {
        equiv: {
          'http-equiv': 'Content-Type',
          content: 'text/html; charset=UTF-8'
        },

        description: {
          name: 'description',
          template() {
            return `${truncate(item.description_clean, 147) || ''}`
          }
        },
        ogType: {
          property: 'og:type',
          template() {
            return 'og:product'
          }
        },

        // note: for Open Graph type metadata you will need to use SSR, to ensure page is rendered by the server
        ogTitle: {
          property: 'og:title',

          // optional; similar to titleTemplate, but allows templating with other meta properties
          template() {
            return `${item.seo_title || ''}`
          }
        },
        ogDescription: {
          property: 'og:description',
          template() {
            return `${item.description_clean || ''}`
          }
        },

        ogUrl: {
          property: 'og:url',
          template() {
            return `${item.seo_link}`
          }
        },

        ogImage: {
          property: 'og:image',
          template() {
            return `${item.cover_image_og?.image.path}`
          }
        },

        ogImageUrl: {
          property: 'og:image:url',
          template() {
            return `${item.cover_image_og?.image.path}`
          }
        },

        ogImageWidth: {
          property: 'og:image:width',
          template() {
            return '1200'
          }
        },

        ogImageType: {
          property: 'og:image:type',
          template() {
            return 'image/jpeg'
          }
        },

        ogRich_attachment: {
          property: 'og:rich_attachment',
          template() {
            return true
          }
        },

        ogImageAlt: {
          property: 'og:image:alt',
          template() {
            return `${item.seo_title || ''}`
          }
        },

        ogImageHeight: {
          property: 'og:image:height',
          template() {
            return '620'
          }
        },

        twitterImage: {
          property: 'twitter:image',
          template() {
            return `${item.cover_image_og?.image.path}`
          }
        },
        twitterCard: {
          property: 'twitter:card',
          template() {
            return 'summary_large_image'
          }
        },
        twitterSite: {
          property: 'twitter:site',
          template() {
            return '@CamperTrader_de'
          }
        },
        twitterCreator: {
          property: 'twitter:creator',
          template() {
            return '@CamperTrader_de'
          }
        },
        twitterTitle: {
          property: 'twitter:title',
          template() {
            return `${item.seo_title || ''}`
          }
        },
        twitterDescription: {
          property: 'twitter:description',
          template() {
            return `${item.description_clean || ''}`
          }
        }
      }
    } as object
  })
}
setMeta()

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_page = _resolveComponent("q-page")!
  const _directive_track_content = _resolveDirective("track-content")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      (advert.value?.inactive)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_unref($q).screen.lt.sm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_q_btn, {
                    class: "q-my-md",
                    flat: "",
                    icon: "fas fa-arrow-left",
                    round: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (hasHistory.value ? _ctx.$router.go(-1) : _unref(router).push({name: 'search'})))
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createVNode(_component_q_icon, {
                  name: "fas fa-face-sad-tear",
                  size: "3rem"
                })
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-h3" }, "Dieses Inserat ist leider nicht mehr aktiv.", -1)),
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  to: { name: 'search' },
                  color: "primary",
                  rounded: "",
                  unelevated: "",
                  "no-caps": ""
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("Mehr Inserate finden")
                  ])),
                  _: 1,
                  __: [5]
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value && advert.value && !advert.value.inactive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!advert.value.active || advert.value.has_expired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_q_banner, { class: "bg-warning text-white q-py-xl" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          (advert.value.has_expired)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Dieses Inserat ist abgelaufen. ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("Dieses Inserat ist derzeit inaktiv.")
                              ], 64))
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (isOwner.value)
                ? (_openBlock(), _createBlock(DetailEditBar, {
                    key: 1,
                    advert: advert.value,
                    class: "q-my-lg",
                    onUpdateStatus: _cache[1] || (_cache[1] = (val) => advert.value ? advert.value['active'] = val : undefined)
                  }, null, 8, ["advert"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", {
              class: _normalizeClass([{ container: !_unref($q).screen.lt.sm }, "relative-position"])
            }, [
              (_unref($q).screen.lt.sm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_q_btn, {
                          round: "",
                          color: "white",
                          "text-color": "dark",
                          size: "0.65rem",
                          icon: "fas fa-angle-left",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (hasHistory.value ? _ctx.$router.go(-1) : _ctx.$router.push({name: 'search'})))
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(BookmarkBtn, {
                          obj: advert.value,
                          type: "advert"
                        }, null, 8, ["obj"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(DetailHeaderGallery, {
                images: advertImages.value,
                onOpenGallery: _cache[3] || (_cache[3] = val => openGallery(val))
              }, null, 8, ["images"])
            ], 2),
            _createElementVNode("section", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (advert.value?.internal_id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Interne ID: " + _toDisplayString(advert.value.internal_id), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("h1", _hoisted_18, _toDisplayString(advert.value?.title), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_19, [
                            (advert.value?.address && _unref(getCityFromNominatim)(advert.value.address))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createVNode(FlagIcon, {
                                    "country-code": advert.value.address.country
                                  }, null, 8, ["country-code"]),
                                  _createTextVNode(" " + _toDisplayString(_unref(getCityFromNominatim)(advert.value.address)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (advert.value?.vehicle?.seats)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createVNode(_component_q_icon, { name: "airline_seat_recline_normal" }),
                                  _createTextVNode(" " + _toDisplayString(advert.value.vehicle.seats), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (advert.value?.vehicle?.beds)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createVNode(_component_q_icon, {
                                    name: "fas fa-bed",
                                    size: "0.7rem"
                                  }),
                                  _createTextVNode("  " + _toDisplayString(advert.value.vehicle.beds), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (formattedMileage.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createVNode(_component_q_icon, {
                                    name: "fas fa-gauge",
                                    size: "0.7rem"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(formattedMileage.value) + " km ", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (advert.value?.vehicle?.engine_power_ps)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(advert.value?.vehicle.engine_power_ps) + " PS ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (_unref($q).screen.lt.sm)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                            _createVNode(_component_q_chip, {
                              square: "",
                              size: "xl",
                              color: "secondary",
                              "text-color": "dark",
                              class: "q-ma-none",
                              ripple: false
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", null, _toDisplayString(formattedPrice.value), 1),
                                  (advert.value.is_negotiable)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, " VB "))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("section", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_router_link, { to: toProfile.value }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_avatar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_img, {
                                      src: advert.value.by_user?.avatar?.path,
                                      alt: "Profile image",
                                      class: "bg-white",
                                      "no-spinner": ""
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_router_link, {
                              class: "text-bold",
                              to: toProfile.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(advert.value.by_user?.public_name || advert.value.by_user?.name), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", null, _toDisplayString(advert.value.by_user?.is_business ? 'Händler' : 'Privatanbieter'), 1),
                              (dateJoined.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" • Seit " + _toDisplayString(dateJoined.value) + " dabei", 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(FadeOutText, {
                          "max-height": 200,
                          "background-color": "white",
                          style: {"white-space":"pre-line"}
                        }, {
                          default: _withCtx(() => [
                            _cache[7] || (_cache[7] = _createElementVNode("div", null, [
                              _createElementVNode("span", { class: "text-bold" }, "Beschreibung")
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(advert.value?.description || 'Keine Beschreibung'), 1)
                          ]),
                          _: 1,
                          __: [7]
                        })
                      ])
                    ]),
                    (advert.value.vehicle.extras?.length)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                          _createVNode(AdvertDetailExtras, { advert: advert.value }, null, 8, ["advert"])
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_33, [
                      _createVNode(AdvertDetailAd)
                    ])), [
                      [_directive_track_content, {
                    piece: 'HorbachBanner',
                    name: 'AdvertDetailAd1'
                  }]
                    ]),
                    _createElementVNode("section", _hoisted_34, [
                      _createVNode(AdvertEquipmentCard, { advert: advert.value }, null, 8, ["advert"])
                    ]),
                    (advert.value.youtube_link_id)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_35, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_q_separator, { class: "q-my-lg" }),
                            _createElementVNode("iframe", {
                              src: `https://www.youtube-nocookie.com/embed/${advert.value.youtube_link_id}`,
                              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                              allowfullscreen: "",
                              frameborder: "0",
                              style: {"aspect-ratio":"16/9"},
                              title: "YouTube video player",
                              width: "100%"
                            }, null, 8, _hoisted_36)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_37, _cache[8] || (_cache[8] = [
                      _createElementVNode("a", {
                        href: "https://a.partner-versicherung.de/click.php?partner_id=181074&ad_id=1041&deep=kredit",
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          alt: "tarif",
                          src: "https://a.partner-versicherung.de/view.php?partner_id=181074&ad_id=1041",
                          width: "970",
                          height: "250",
                          style: {"max-width":"100%","height":"auto"}
                        })
                      ], -1)
                    ]))), [
                      [_directive_track_content, {
                    piece: 'KreditWerbung',
                    name: 'AdvertDetailAd2'
                  }]
                    ]),
                    _createElementVNode("section", _hoisted_38, [
                      (!isOwner.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, " Nachricht an " + _toDisplayString(advert.value?.by_user?.name), 1),
                            (
                      !isMessageSend.value &&
                      !advert.value.is_messaged &&
                      _unref(mainStore).isLoggedIn
                    )
                              ? (_openBlock(), _createElementBlock("form", {
                                  key: 0,
                                  class: "column q-gutter-y-sm",
                                  onSubmit: _withModifiers(sendMessage, ["prevent"])
                                }, [
                                  _createVNode(_component_q_input, {
                                    ref: "messageInput",
                                    modelValue: message.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((message).value = $event)),
                                    dense: "",
                                    filled: "",
                                    outlined: "",
                                    placeholder: "Schreibe eine Nachricht",
                                    type: "textarea",
                                    onKeydown: _withKeys(sendMessage, ["enter"])
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_41, [
                                    _createVNode(_component_q_btn, {
                                      outline: "",
                                      type: "submit"
                                    }, {
                                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                                        _createTextVNode("Nachricht absenden")
                                      ])),
                                      _: 1,
                                      __: [9]
                                    })
                                  ])
                                ], 32))
                              : (advert.value.is_messaged)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("div", null, " Du hast bereits " + _toDisplayString(advert.value.by_user?.name) + " eine Nachricht gesendet. ", 1),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_router_link, { to: {name: 'messenger-chat'} }, {
                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                          _createTextVNode("Zu deinen Nachrichten ")
                                        ])),
                                        _: 1,
                                        __: [10]
                                      })
                                    ])
                                  ]))
                                : (!_unref(mainStore).isLoggedIn)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _cache[12] || (_cache[12] = _createElementVNode("div", null, "Du musst eingeloggt sein.", -1)),
                                      _createVNode(_component_router_link, { to: { name: 'login' } }, {
                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                          _createTextVNode(" Zum Login ")
                                        ])),
                                        _: 1,
                                        __: [11]
                                      })
                                    ]))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createVNode(_component_q_banner, { class: "text-white bg-positive" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Deine Nachricht an " + _toDisplayString(advert.value.by_user?.name) + " wurde versendet. ", 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_router_link, { to: {name: 'messenger-chat'} }, {
                                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode("Nachrichten einsehen ")
                                          ])),
                                          _: 1,
                                          __: [13]
                                        })
                                      ])
                                    ], 64))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (advert.value.lat_lng)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_44, [
                          _createVNode(AdvertLocationMap, {
                            "is-business": !!advert.value.by_business,
                            lat: advert.value.lat_lng[0],
                            lng: advert.value.lat_lng[1]
                          }, null, 8, ["is-business", "lat", "lng"]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", null, " Letzte Änderung: " + _toDisplayString(_unref(Filter).i18nDateTime(advert.value?.vehicle.updated_at)), 1),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("a", {
                                href: `mailto:report@campertrader.de?subject=Advert Report ${advert.value.uuid}`,
                                target: "_blank"
                              }, " Inserat melden ", 8, _hoisted_47)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!advert.value.by_business)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                          _createVNode(AdvertDetailCrossSellingProducts, { advert: advert.value }, null, 8, ["advert"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("div", {
                        ref_key: "priceBox",
                        ref: priceBox,
                        class: "price-box rounded-borders q-pa-md q-card--bordered bg-white"
                      }, [
                        _createElementVNode("div", _hoisted_52, [
                          (advert.value?.price)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(formattedPrice.value), 1))
                            : _createCommentVNode("", true),
                          (advert.value.is_negotiable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, " Verhandlungsbasis "))
                            : _createCommentVNode("", true),
                          _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                            _createElementVNode("div")
                          ], -1))
                        ]),
                        _createVNode(_component_q_separator, { class: "q-my-md" }),
                        (advert.value.is_virtual_tour)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _createVNode(_component_q_img, {
                                src: require('src/assets/360-camera_64px_grey.png'),
                                width: "24px"
                              }, null, 8, ["src"]),
                              _cache[15] || (_cache[15] = _createTextVNode("  ")),
                              _cache[16] || (_cache[16] = _createElementVNode("b", null, "Online-Besichtigungen", -1)),
                              _cache[17] || (_cache[17] = _createTextVNode(" möglich "))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _createVNode(MessageUserButton, {
                            "advert-uuid": advert.value.uuid,
                            class: "rounded-borders full-width",
                            "show-modal": false,
                            label: "Nachricht senden",
                            big: "",
                            size: "1rem"
                          }, null, 8, ["advert-uuid"])
                        ]),
                        (advert.value.contact_phone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createVNode(_component_q_banner, { class: "bg-grey-3 text-center rounded-borders" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, { name: "fas fa-phone" }),
                                  (clickedShowPhone.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _cache[18] || (_cache[18] = _createTextVNode("   ")),
                                        _createElementVNode("a", {
                                          href: `tel:${advert.value.contact_phone}`,
                                          class: "text-h4"
                                        }, _toDisplayString(advert.value.contact_phone), 9, _hoisted_57)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _cache[19] || (_cache[19] = _createTextVNode("   ")),
                                        _createElementVNode("a", {
                                          href: "#",
                                          onClick: _withModifiers(showPhone, ["prevent"])
                                        }, " Telefonnummer anzeigen ")
                                      ], 64))
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_q_separator, { class: "q-my-md" }),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _createVNode(BookmarkBtn, {
                                "no-wrap": "",
                                color: "grey-8",
                                class: "full-width",
                                obj: advert.value,
                                type: "advert",
                                round: false
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(advert.value?.is_favorite ? 'Gemerkt' : 'Merken'), 1)
                                ]),
                                _: 1
                              }, 8, ["obj"])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_component_q_btn, {
                                "no-wrap": "",
                                class: "full-width",
                                outline: "",
                                color: "grey-8",
                                loading: loadingShare.value,
                                onClick: share
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "fas fa-share-alt",
                                    size: "xs"
                                  }),
                                  _cache[20] || (_cache[20] = _createTextVNode("  Teilen "))
                                ]),
                                _: 1,
                                __: [20]
                              }, 8, ["loading"])
                            ])
                          ])
                        ]),
                        _createVNode(_component_q_separator, { class: "q-my-md" }),
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-muted text-caption" }, "Werbung", -1)),
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-h3 font-inter-bold q-mt-md" }, " Günstig finanzieren lassen! ", -1)),
                          _createElementVNode("div", {
                            id: "tcpp-widget-kredit",
                            style: {"width":"100%"},
                            "data-target": "_blank",
                            "data-form": "https://www.tarifcheck.de/kredit/ergebnis/",
                            "data-duration": "24",
                            "data-purpose": "2",
                            "data-tracking": "adverts",
                            "data-amount": advert.value.price
                          }, null, 8, _hoisted_61)
                        ])), [
                          [_directive_track_content, {
                        piece: 'KreditWerbungRechner',
                        name: 'AdvertDetailAd2'
                      }]
                        ])
                      ], 512)
                    ])), [
                      [_unref(vOnEleLoad), priceBoxOnLoad]
                    ])
                  ])
                ])
              ]),
              _createVNode(AdvertRecommendation, {
                "advert-uuid": advert.value.uuid
              }, null, 8, ["advert-uuid"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, {
        "leave-active-class": "animated fadeOutDown",
        "enter-active-class": "animated fadeInUp"
      }, {
        default: _withCtx(() => [
          (advert.value?.active && _unref($q).screen.lt.sm && showFixedBar.value)
            ? (_openBlock(), _createBlock(FixedAdvertDetailFooterBar, {
                key: 0,
                class: "footer__fix",
                advert: advert.value,
                "can-click-phone": !!(_unref(mainStore).loggedInState || advert.value.by_business),
                "phone-number": advert.value.contact_phone
              }, null, 8, ["advert", "can-click-phone", "phone-number"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})